import { useFocusTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setFocusSelectedBoards } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListBoards } from '../../components/filters-list/filters-list-boards';
import { useContributingBoards } from '../../initiative-performance.hooks';

export const FiltersBoards = () => {
  const contributingBoards = useContributingBoards();
  const selectedBoards = useFocusTabStore((state) => state.selectedBoards);

  return (
    <FiltersListBoards
      boards={contributingBoards}
      selectedBoards={selectedBoards}
      onSelectBoards={setFocusSelectedBoards}
    />
  );
};
